import { atom } from "jotai";

export const BookviewSearchTermAtom = atom<string>("");
